export function getUserInfo() {
  return new Promise(resolve => {
    window.setUserInfo = info => {
      resolve(info)
    }
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        // window.setUserInfo('{"mobile": "15913133060", "email": ""}')
        // window.setUserInfo('{"mobile": "18648911204", "email": "414397541@qq.com"}')
      }, 100)
    }
    if (window.webkit) {
      // ios
      window.webkit.messageHandlers.native.postMessage('setUserInfo')
    } else if (window.native && window.native.sendMessage) {
      // android
      window.native.sendMessage('setUserInfo')
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/native.js